<template>
  <form id="edit_user_form">
    <div class="card card-custom gutter-b">
      <div class="card-header">
        <div class="card-title">
          <h3 class="card-label" dir="ltr">
            {{ gFullName(companyUser) }}
          </h3>
        </div>
      </div>
      <div class="card-body">
        <div class="container">
          <div class="row">
            <div class="form-group col-6">
              <label>نام</label>
              <input
                type="text"
                name="first_name"
                v-model="form.first_name"
                class="form-control form-control-solid"
              />
            </div>
            <div class="form-group col-6">
              <label>نام خانوادگی</label>
              <input
                type="text"
                name="last_name"
                v-model="form.last_name"
                class="form-control form-control-solid"
              />
            </div>
            <div class="form-group col-6">
              <label>ایمیل</label>
              <input
                type="email"
                name="email"
                v-model="form.email"
                class="form-control form-control-solid"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SET_ACTIONS } from "@/core/services/store/actions.module";
import formValidation from "@/assets/plugins/formvalidation/dist/es6/core/Core";
import Trigger from "@/assets/plugins/formvalidation/dist/es6/plugins/Trigger";
import Swal from "sweetalert2";
import Bootstrap from "@/assets/plugins/formvalidation/dist/es6/plugins/Bootstrap";
import {
  DESTROY_COMPANY_USER,
  FETCH_COMPANY_USER,
  UPDATE_COMPANY_USER
} from "@/core/services/store/company/users.module";
import { mapGetters } from "vuex";
import _ from "lodash";

export default {
  name: "companyUsersEditreate",
  data() {
    return {
      loaded: false,
      form: {}
    };
  },
  beforeMount() {
    const { id: userId } = this.$route.params;
    this.loaded = false;
    this.$store
      .dispatch(FETCH_COMPANY_USER, userId)
      .then(() => {
        this.$store.dispatch(SET_BREADCRUMB, [
          {
            title: this.currentUserProperty.title ?? "شرکت",
            route: { name: "company-dashboard" }
          },
          { title: "کاربران", route: { name: "company-users-index" } },
          { title: this.gFullName(this.companyUser) }
        ]);

        this.loaded = true;
      })
      .catch(() => {
        this.loaded = true;
      });
  },
  mounted() {
    this.$store.dispatch(SET_ACTIONS, {
      buttons: [
        {
          name: "ذخیره",
          event: "edit-user-event",
          class: "btn-primary",
          id: "edit-user-btn"
        },
        {
          name: '<i class="flaticon2-trash"></i>حذف',
          event: "delete-user-event",
          class: "btn-danger"
        }
      ],
      links: [
        {
          name: "بازگشت",
          to: { name: "company-users-index" }
        }
      ]
    });
    this.eventHub.$on("edit-user-event", this.save);
    this.eventHub.$on("delete-user-event", this.destroy);

    this.fv = formValidation(document.getElementById("edit_user_form"), {
      fields: {
        first_name: {
          validators: {
            notEmpty: {
              message: "نام صحیح نیست."
            }
          }
        },
        last_name: {
          validators: {
            notEmpty: {
              message: "نام صحیح نیست."
            }
          }
        },
        email: {
          validators: {
            emailAddress: {
              message: "ایمیل صحیح نیست."
            }
          }
        }
      },
      plugins: {
        trigger: new Trigger(),
        bootstrap: new Bootstrap()
      }
    });
  },
  beforeDestroy() {
    this.eventHub.$off(["edit-user-event", "delete-user-event"]);
    document.getElementById("edit-user-btn").disabled = false;
  },
  watch: {
    originalForm: {
      handler() {
        this.form = _.cloneDeep(this.originalForm);
      },
      deep: true
    },

    form: {
      handler() {
        document.getElementById("edit-user-btn").disabled = _.isEqual(
          this.form,
          this.originalForm
        );
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters(["currentUserProperty", "companyUser"]),
    originalForm() {
      if (!this.loaded) {
        return;
      }
      return {
        user: this.companyUser.id,
        first_name: this.companyUser.first_name,
        last_name: this.companyUser.last_name,
        email: this.companyUser.email,
        is_company_user: true,
        is_referred_user: false
      };
    }
  },
  methods: {
    save() {
      this.fv.validate().then(status => {
        if (status === "Valid") {
          let submitBtn = document.getElementById("edit-user-btn");
          this.disableBtn(submitBtn);
          this.$store
            .dispatch(UPDATE_COMPANY_USER, this.form)
            .then(user => {
              this.enableBtn(submitBtn);
              this.$router.push({
                name: "company-users-show",
                params: { id: user.id }
              });
            })
            .catch(() => {
              this.enableBtn(submitBtn);
            });
        } else if (status === "Invalid") {
          this.showError("لطفا فرم را به شکل صحیح کامل کنید");
        }
      });
    },
    destroy() {
      let id = this.$route.params.id;
      Swal.fire({
        title: "",
        text: "آیا از حذف کاربر اطمینان دارید؟",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "بله",
        confirmButtonColor: "#4554a0",
        cancelButtonText: "خیر",
        cancelButtonColor: "#ed1c24",
        heightAuto: false
      }).then(result => {
        if (result.isConfirmed) {
          this.$store.dispatch(DESTROY_COMPANY_USER, id).then(() => {
            this.$router.push({
              name: "company-users-index"
            });
          });
        }
      });
    }
  }
};
</script>
